import { reactive } from 'vue'
import type { ImageLightFitMode, ImageLightOptions } from './types'

export type ImageLightApplyStatus = 'idle' | 'loading' | 'success' | 'error' | 'playing'

export const imageLightState = reactive({
  status: 'idle' as ImageLightApplyStatus,
  fileName: '',
  errorKey: '',
  fitMode: 'contain' as ImageLightFitMode,
  brightness: 100,
  backgroundColor: '#000000',
  offsetX: 0,
  offsetY: 0,
  scale: 1,
  previewUrl: '',
  activeKind: 'none' as 'none' | 'static' | 'dynamic',
  activeSource: 'color' as 'color' | 'image',
  persistedSource: 'none' as 'none' | 'static' | 'dynamic' | 'color',
  hasApplied: false,
  frameCount: 0,
  currentFrame: 0,
  loop: true,
})

export const hexToRgbNumber = (value: string) => {
  const normalized = value.replace('#', '')
  if (!/^[0-9a-fA-F]{6}$/.test(normalized)) {
    return 0
  }
  return Number.parseInt(normalized, 16)
}

export const createImageLightOptions = (): ImageLightOptions => ({
  fitMode: imageLightState.fitMode,
  brightness: imageLightState.brightness,
  backgroundColor: hexToRgbNumber(imageLightState.backgroundColor),
  offsetX: imageLightState.offsetX,
  offsetY: imageLightState.offsetY,
  scale: imageLightState.scale,
})

export const revokeImageLightPreviewUrl = () => {
  if (!imageLightState.previewUrl) return
  URL.revokeObjectURL(imageLightState.previewUrl)
  imageLightState.previewUrl = ''
}

export const setImageLightPreviewFile = (file: File) => {
  revokeImageLightPreviewUrl()
  imageLightState.previewUrl = URL.createObjectURL(file)
}

export const resetImageLightPlacement = () => {
  imageLightState.offsetX = 0
  imageLightState.offsetY = 0
  imageLightState.scale = 1
}

export const applyPersistedImageLightOptions = (options: ImageLightOptions) => {
  imageLightState.fitMode = options.fitMode
  imageLightState.brightness = options.brightness
  imageLightState.backgroundColor = `#${options.backgroundColor.toString(16).padStart(6, '0')}`
  imageLightState.offsetX = options.offsetX
  imageLightState.offsetY = options.offsetY
  imageLightState.scale = options.scale
}
